<script setup lang="ts">
import { useAccountStore } from "@/stores/account";
import { computed, ref, watch } from "vue";
import { PullRefresh, Loading } from "vant";
import { useTaskStore } from "@/stores/task";
const accountStore = useAccountStore();
const searchWords = ref<string>();
const pullLoading = ref<boolean>(false);
const listLoading = ref<boolean>(false);
const baseToken = ["AMAX", "MUSDT", "MBTC", "METH", "MBNB"];
const taskStore = useTaskStore()
const props = defineProps({
  isShow: Boolean,
  onCancel: Function,
  title: String,
  explaination: String,
});

const emit = defineEmits(["update:isShow"]);

const cancelFn: Function = (): void => {
  console.log("enter cancel");
  props.onCancel && props.onCancel();
  emit("update:isShow", false);
};

const handleSelect = (data: any) => {
  if (data.disabled) {
    return false;
  }
};

const onRefresh = () => {
  accountStore.getTokensByAccount();
};

watch(
  () => props.isShow,
  (newVal) => {
    if (newVal) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "inherit";
    }
  }
);
</script>

<template>
  <teleport to="body">
    <div class="m-modal-wrap">
      <div
        class="m-shadow"
        @click="cancelFn()"
        :class="{ 'z-show': isShow }"
      ></div>
      <div class="m-modal media-375" :class="{ 'z-show': isShow }">
        <div class="line"></div>
        <div class="m-modal-header">
          <div class="title number-font flex-row-center-center">
            <span>{{ props.title }}</span>
          </div>
        </div>
        <p class="explaination">
          <slot />
        </p>
        <!-- <div class="confirm-btn" @click="cancelFn()">
          {{ $t("Common.I got it") }}
        </div> -->
      </div>
    </div>
  </teleport>
</template>

<style lang="scss" scoped>
.m-modal-wrap {
  .m-shadow {
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.7);
    backdrop-filter: blur(5px);
    transition: all 0.5s;
    display: none;
    z-index: 999;

    &.z-show {
      display: block;
    }
  }

  .m-modal {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    transform: translateY(100%);
    transition: all 0.5s;
    z-index: 1000;
    padding-top: 12px;
    border-radius: 12px 12px 0px 0px;
    background: #071412;
    .line{
      width: 48px;
      height: 4px;
      border-radius: 23px;
      background: rgba(255, 255, 255, 0.10);
    }
    .setup-loading {
      margin-top: 10px;
    }

    &.z-show {
      transform: translateY(0);
    }

    &-header {
      .line {
        width: 48px;
        height: 4px;
        border-radius: 23px;
        background: #d9d9d9;
        margin-bottom: 24px;
      }

      .title {
        font-size: 16px;
        color: #fff;
        padding-top: 20px;
        font-weight: 500;
      }
    }

    .explaination {
      line-height: 1.6;
      color: #666;
      font-size: 13px;
      margin-top: 8px;
      text-align: center;
      word-break: break-all;
      /* margin: 24px auto; */
    }

    .confirm-btn {
      width: 192px;
      height: 58px;
      text-align: center;
      line-height: 58px;
      font-size: 24px;
      font-weight: 500;
      margin: 0 auto;
      color: #fff;
      background: url(../../assets/btn-able.png);
      background-size: contain;
      background-repeat: no-repeat;
    }
  }
}
</style>
